import { connect } from "react-redux";
import NoItems from "../../../presentational/customerItems/NoItems";
import { getUserIsAuthenticated } from "../../../../state/selectors";

const mapStateToProps = state => ({
  isAuthenticated: getUserIsAuthenticated(state)
});

export default connect(mapStateToProps)(NoItems);
